"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refreshData = exports.getSummaryData = exports.GET_SUMMARY_DATA_FAILURE = exports.GET_SUMMARY_DATA_SUCCESS = exports.GET_SUMMARY_DATA_REQUEST = exports.getIntervalDataDirectory = exports.GET_METADATA_DIRECTORY_FAILURE = exports.GET_METADATA_DIRECTORY_SUCCESS = exports.GET_METADATA_DIRECTORY_REQUEST = exports.resetMetadataDirectory = exports.RESET_METADATA_DIRECTORY = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _actions = require("kmap-redux/dist/actions");

var _kubraKmap = _interopRequireDefault(require("kubra-kmap"));

var _api = require("../middleware/api");

var _SC4Data = require("../api/SC4Data");

var _infoboxActions = require("./infoboxActions");

var _mapActions = require("./mapActions");

var _messageActions = require("./messageActions");

var _layers = require("../config/layers");

var _clusterTf = _interopRequireDefault(require("../assets/cluster-tf.svg"));

var _managedTf = _interopRequireDefault(require("../assets/managed-tf.svg"));

var _bothTf = _interopRequireDefault(require("../assets/both-tf.svg"));

var _criticalTf = _interopRequireDefault(require("../assets/critical-tf.svg"));

var _Legend = require("../components/Legend");

var _permissions = _interopRequireWildcard(require("../config/permissions"));

var _loadshedActions = require("./loadshedActions");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var RESET_METADATA_DIRECTORY = 'RESET_METADATA_DIRECTORY';
exports.RESET_METADATA_DIRECTORY = RESET_METADATA_DIRECTORY;

var resetMetadataDirectory = function resetMetadataDirectory() {
  return function (dispatch) {
    dispatch({
      type: RESET_METADATA_DIRECTORY
    });
  };
};

exports.resetMetadataDirectory = resetMetadataDirectory;
var GET_METADATA_DIRECTORY_REQUEST = 'GET_METADATA_DIRECTORY_REQUEST';
exports.GET_METADATA_DIRECTORY_REQUEST = GET_METADATA_DIRECTORY_REQUEST;
var GET_METADATA_DIRECTORY_SUCCESS = 'GET_METADATA_DIRECTORY_SUCCESS';
exports.GET_METADATA_DIRECTORY_SUCCESS = GET_METADATA_DIRECTORY_SUCCESS;
var GET_METADATA_DIRECTORY_FAILURE = 'GET_METADATA_DIRECTORY_FAILURE';
exports.GET_METADATA_DIRECTORY_FAILURE = GET_METADATA_DIRECTORY_FAILURE;

var getIntervalDataDirectory = function getIntervalDataDirectory(url, callback, errorCallback) {
  return _defineProperty({}, _api.CALL_API, {
    types: [GET_METADATA_DIRECTORY_REQUEST, GET_METADATA_DIRECTORY_SUCCESS, GET_METADATA_DIRECTORY_FAILURE],
    request: function request() {
      return (0, _SC4Data.getDataDirectory)(url);
    },
    callback: callback,
    errorCallback: errorCallback
  });
};

exports.getIntervalDataDirectory = getIntervalDataDirectory;
var GET_SUMMARY_DATA_REQUEST = 'GET_SUMMARY_DATA_REQUEST';
exports.GET_SUMMARY_DATA_REQUEST = GET_SUMMARY_DATA_REQUEST;
var GET_SUMMARY_DATA_SUCCESS = 'GET_SUMMARY_DATA_SUCCESS';
exports.GET_SUMMARY_DATA_SUCCESS = GET_SUMMARY_DATA_SUCCESS;
var GET_SUMMARY_DATA_FAILURE = 'GET_SUMMARY_DATA_FAILURE';
exports.GET_SUMMARY_DATA_FAILURE = GET_SUMMARY_DATA_FAILURE;

var getSummaryData = function getSummaryData(url, callback, errorCallback) {
  return _defineProperty({}, _api.CALL_API, {
    types: [GET_SUMMARY_DATA_REQUEST, GET_SUMMARY_DATA_SUCCESS, GET_SUMMARY_DATA_FAILURE],
    request: function request() {
      return (0, _SC4Data.getSummaryDataFile)(url);
    },
    callback: callback,
    errorCallback: errorCallback
  });
};

exports.getSummaryData = getSummaryData;

var refreshData = function refreshData(userType, userMuniCounty) {
  return function (dispatch, getState) {
    dispatch({
      type: 'REFRESH_DATA'
    });
    var currentInterval = getState().metadataReducer.metadata;
    dispatch(getIntervalDataDirectory('./resources/data/loadshed/interval_generation_data/metadata.json', function (metadata) {
      if (metadata && metadata.directory === currentInterval) {
        return;
      } //  Get all layers allowed by the user type by checking the index file.


      dispatch((0, _loadshedActions.getUsersLayers)("./resources/data/loadshed/interval_generation_data/".concat(metadata.directory, "/thematic_loadshed/loadshed_index.json"), function (layerMetadata) {
        var userLayerMetadata = layerMetadata[userMuniCounty] || layerMetadata[_permissions.DEFAULT_COUNTY_MUNI]; // eslint-disable-next-line no-console

        console.log("Using operations for: ".concat(layerMetadata[userMuniCounty] ? userMuniCounty : _permissions.DEFAULT_COUNTY_MUNI)); //  Uses LAYER_COLORS as the base array to ensure correct sorting

        var layers = Object.keys(_layers.LAYER_COLORS).map(function (e) {
          return (0, _layers.getLayerFrom)(e, userLayerMetadata);
        }).filter(function (e) {
          return e !== undefined;
        });
        layers.push(_layers.transformerLayer);
        dispatch((0, _loadshedActions.setLoadshedLayers)(layers)); // dispatch(getSummaryData(`/resources/data/external/interval_generation_data/${metadata.directory}/data.json`, (): void => {}, (): void => {}));
        // load layers

        Promise.all(layers.map(function (layer) {
          return dispatch((0, _actions.removeLayer)(layer.name));
        })).then(function () {
          Promise.all(layers.filter(function (layer) {
            return !layer.name.includes('transformer');
          }).map(function (layer) {
            return dispatch((0, _actions.loadLayer)(layer.name, ["./resources/data/loadshed/interval_generation_data/".concat(metadata.directory, "/thematic_loadshed/").concat(layer.name, ".json")], {
              type: _kubraKmap.default.layerType.VECTOR,
              format: _kubraKmap.default.layerFormat.JSON,
              compress: true,
              zIndex: 200,
              showMarker: _kubraKmap.default.layerShowMarker.NEVER,
              showShape: _kubraKmap.default.layerShowShape.ALWAYS,
              clickable: true,
              visible: false,
              style: {
                ranges: [{
                  rangeCriteria: [{
                    field: 'cluster',
                    condition: '!=',
                    value: true
                  } // { field: 'n_out', condition: '>=', value: 50 },
                  // { field: 'type', condition: '=', value: 'COMBINED' },
                  // {field: "cust_a.val", condition: ">", value: 1},
                  ],
                  rangeStyles: {
                    shape: {
                      borderColor: layer.color,
                      borderOpacity: 0.1,
                      borderWeight: 1,
                      fillColor: layer.color,
                      opacity: 0.6
                    },
                    icon: {
                      url: '/images/infobox/hazard_icon.svg',
                      size: [0, 0],
                      anchor: [20, 16.5],
                      // eslint-disable-next-line no-template-curly-in-string
                      labelValue: null,
                      labelAnchor: null,
                      labelTextColor: '#fff',
                      opacity: 0
                    }
                  },
                  rangeLegendIcon: undefined,
                  showInLegend: false
                }]
              }
            }));
          })).then(function () {
            // then add click listeners for infobox
            Promise.all(layers.filter(function (layer) {
              return !layer.name.includes('transformer');
            }).map(function (layer) {
              return dispatch((0, _actions.layerRegisterEvent)(layer.name, _kubraKmap.default.layerEvent.CLICK, function (e) {
                e.layer = layer;
                dispatch((0, _infoboxActions.selectOutage)(e));
              }));
            }));
          });
        });
        Promise.resolve().then(function () {
          _axios.default.get('./resources/data/external/interval_generation_data/metadata.json').then(function (res) {
            var eoutagesMetadata = res.data.directory;
            var tfLink = _permissions.default[userType].allowAllTransformers ? 'allTF' : 'allCriticalTF';

            if (eoutagesMetadata) {
              dispatch((0, _actions.loadLayer)('transformers', ["./resources/data/external/interval_generation_data/".concat(eoutagesMetadata, "/").concat(tfLink, "/{q}.json")], {
                type: _kubraKmap.default.layerType.VECTOR,
                format: _kubraKmap.default.layerFormat.JSON,
                compress: true,
                zIndex: 200,
                showMarker: _kubraKmap.default.layerShowMarker.NEVER,
                showShape: _kubraKmap.default.layerShowShape.ALWAYS,
                clickable: true,
                visible: getState().mapViewReducer.mapView.zoom > _Legend.zoomPoint,
                style: {
                  ranges: [{
                    rangeCriteria: [{
                      field: 'cluster',
                      condition: '=',
                      value: true
                    }, {
                      field: 'n_out',
                      condition: '<',
                      value: 50
                    } // { field: 'type', condition: '=', value: 'COMBINED' },
                    // {field: "cust_a.val", condition: ">", value: 1},
                    ],
                    rangeStyles: {
                      shape: null,
                      icon: {
                        url: _clusterTf.default,
                        size: [40, 40],
                        anchor: [20, 20],
                        // eslint-disable-next-line no-template-curly-in-string
                        labelValue: '${n_out}',
                        labelAnchor: [20, 21]
                      }
                    },
                    rangeLegendIcon: undefined,
                    showInLegend: false
                  }, {
                    rangeCriteria: [{
                      field: 'cluster',
                      condition: '=',
                      value: true
                    }, {
                      field: 'n_out',
                      condition: '>=',
                      value: 50
                    } // { field: 'type', condition: '=', value: 'COMBINED' },
                    // {field: "cust_a.val", condition: ">", value: 1},
                    ],
                    rangeStyles: {
                      shape: null,
                      icon: {
                        url: _clusterTf.default,
                        size: [40, 40],
                        anchor: [20, 20],
                        // eslint-disable-next-line no-template-curly-in-string
                        labelValue: '50+',
                        labelAnchor: [20, 21]
                      }
                    },
                    rangeLegendIcon: undefined,
                    showInLegend: false
                  }, {
                    rangeCriteria: [{
                      field: 'cluster',
                      condition: '=',
                      value: false
                    }, {
                      field: 'type',
                      condition: '=',
                      value: 'JOC'
                    } // { field: 'type', condition: '=', value: 'COMBINED' },
                    // {field: "cust_a.val", condition: ">", value: 1},
                    ],
                    rangeStyles: {
                      shape: null,
                      icon: {
                        url: _criticalTf.default,
                        size: [25, 25],
                        anchor: [12, 12],
                        // eslint-disable-next-line no-template-curly-in-string
                        labelValue: null,
                        labelAnchor: [20, 21]
                      }
                    },
                    rangeLegendIcon: undefined,
                    showInLegend: false
                  }, {
                    rangeCriteria: [{
                      field: 'cluster',
                      condition: '=',
                      value: false
                    }, {
                      field: 'type',
                      condition: '=',
                      value: 'LCS'
                    } // { field: 'type', condition: '=', value: 'COMBINED' },
                    // {field: "cust_a.val", condition: ">", value: 1},
                    ],
                    rangeStyles: {
                      shape: null,
                      icon: {
                        url: _managedTf.default,
                        size: [25, 25],
                        anchor: [12, 12],
                        // eslint-disable-next-line no-template-curly-in-string
                        labelValue: null,
                        labelAnchor: [20, 21]
                      }
                    },
                    rangeLegendIcon: undefined,
                    showInLegend: false
                  }, {
                    rangeCriteria: [{
                      field: 'cluster',
                      condition: '=',
                      value: false
                    }, {
                      field: 'type',
                      condition: '=',
                      value: 'BOTH'
                    } // { field: 'type', condition: '=', value: 'COMBINED' },
                    // {field: "cust_a.val", condition: ">", value: 1},
                    ],
                    rangeStyles: {
                      shape: null,
                      icon: {
                        url: _bothTf.default,
                        size: [25, 25],
                        anchor: [12, 12],
                        // eslint-disable-next-line no-template-curly-in-string
                        labelValue: null,
                        labelAnchor: [20, 21]
                      }
                    },
                    rangeLegendIcon: undefined,
                    showInLegend: false
                  }]
                }
              }));
            }
          }).then(function () {
            dispatch((0, _actions.layerRegisterEvent)('transformers', _kubraKmap.default.layerEvent.CLICK, function (e) {
              e.layer = layers.find(function (layer) {
                return layer.name === 'transformers';
              });
              dispatch((0, _infoboxActions.selectOutage)(e));
            }));
          }).then(function () {
            // then set default visibility
            var activeLayer = getState().layerVisibilityReducer.activeLayer;

            if (activeLayer) {
              activeLayer.forEach(function (layerName) {
                dispatch((0, _actions.setLayerVisibility)(layerName, undefined, true));
              });
            }

            dispatch({
              type: _mapActions.VIEW_CHANGED,
              view: getState().mapViewReducer.mapView
            });
          });
        });
      }, function () {
        dispatch({
          type: _messageActions.SHOW_MESSAGE,
          message: 'Could not reach map data',
          fullScreen: true
        });
      }));
    }, function () {
      dispatch({
        type: _messageActions.SHOW_MESSAGE,
        message: 'Could not reach map data',
        fullScreen: true
      });
    }));
  };
};

exports.refreshData = refreshData;